module.exports = __webpack_public_path__ + "8609904ddea34501146bd824ff5d1d4b.jpg";